import { default as StashActionBar } from './StashActionBar';
import { default as StashActionBarNew } from './StashActionBar.private_sell';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    private_sell: StashActionBarNew
})(StashActionBar);

//# sourceMappingURL=index.js.map